import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import './Landing.scss';
import { createGame } from '../redux/gameSlice';
import { useDispatch } from 'react-redux';
import { useRef } from 'react';
import { useEffect } from 'react';
import { Trans } from '@lingui/macro';
import LanguageSelector from './LanguageSelector';

function Landing(props) {
  const [showingJoinOverlay, setShowingJoinOverlay] = useState(false);
  const [roomId, setRoomId] = useState("");
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  function updateRoomId(event) {
    let newRoomId = event.target.value;
    const matchUrl = newRoomId.length > 7 ? newRoomId.match(/\/game\/(\w{6})/) : false;
    if (matchUrl) {
      newRoomId = matchUrl[1].toUpperCase();
    }

    setRoomId(newRoomId.slice(0, 6).toUpperCase());
  };

  function clickOverlay(ev) {
    if (ev.target.id === "game-join-overlay" || ev.target.classList.contains("fa-times")) {
      setShowingJoinOverlay(false);
    }
  }

  const showJoinOverlay = () => setShowingJoinOverlay(true);

  useEffect(() => {
    if (showingJoinOverlay) {
      inputRef.current.focus();
    }
  }, [inputRef, showingJoinOverlay]);

  const joinGame = (roomId) => {
    props.history.push('/game/' + roomId);
  };

  function handlePressingEsc(ev) {
    ev.stopPropagation();
    // Check if hitting ESC
    if (ev.keyCode === 27) {
      setShowingJoinOverlay(false);
    }
  }

  if (showingJoinOverlay) {
    window.addEventListener("keydown", handlePressingEsc);
  }
  else {
    window.removeEventListener("keydown", handlePressingEsc);
  }

  const avg_game_duration = 30;
  return <div id="landing" className="noselect">
    <div id="landing-content">
      <div id="game-symbols">
        <div className="symbol">
          <p><i className="far fa-clock"></i></p>
          <p className="symbol-description">
            <Trans id="landing.average_duration">{avg_game_duration} min</Trans>
          </p>
        </div>
        <div className="symbol">
          <p><i className="fas fa-users"></i></p>
          <p className="symbol-description">
            <Trans id="landing.player_count">2-6 players</Trans>
          </p>
        </div>
      </div>
      <div id="main-content-wrap">
        <div id="action-container">
          <p className="landing-big-text"><Trans id="landing.big_text">Become the king by beating everyone!</Trans></p>
          <p className="landing-normal-text"><Trans id="landing.subtext">King of the Town is a turn-based browser game to play with your family and friends</Trans></p>
          <div id="action-buttons" className="noselect">
            <button type="submit" className="button" id="join-game" onClick={showJoinOverlay}>
              <Trans id="landing.join_btn">JOIN GAME</Trans>
            </button>
            <button type="submit" className="button" id="create-game" onClick={() => dispatch(createGame(props.history))}>
              <Trans id="landing.create_btn">CREATE NEW GAME</Trans>
            </button>
          </div>
        </div>
        <div id="illustration-container">
          <div id="logo"></div>
          <div id="monsters-container">
            <div className="monster flying-octopus"></div>
            <div className="monster mustache-wizard"></div>
            <div className="monster nautical-crab"></div>
          </div>
        </div>
      </div>
      <div id="buy-me-coffee-container">
      </div>
      <LanguageSelector />
    </div>
    <div id="game-join-overlay" className={`esc-overlay overlay-background dark-background-overlay ${!showingJoinOverlay ? 'hidden' : ''}`} onClick={clickOverlay}>
      <div className="overlay-wrapper">
        <i className="fas fa-times"></i>
        <div id="game-join-image" className="rey-regular"></div>
        <div id="circle-behind-game-join-image"></div>
        <div id="game-join-input-container">
          <div className="overlay-title">
            <Trans id="landing.join_overlay.title">Join Game</Trans>
          </div>
          <div className="overlay-text-explanation">
            <Trans id="landing.join_overlay.desc">Please insert the game room ID of the match you are trying to join, below</Trans>
          </div>
          <form id="input-container" onSubmit={() => joinGame(roomId)}>
            <input name="room-id" id="room-id" placeholder="AX71AS" value={roomId} onChange={updateRoomId} autoComplete="off" ref={inputRef} />
            <button type="submit" className="button" id="send-room-id" disabled={roomId.length !== 6}>
              <span className="button-content-fixed-width"><i className="fas fa-caret-right"></i></span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div >;
}

export default withRouter(Landing); // Adds router props like this.props.history
